import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            height: {base: remCalc(164), md: remCalc(330)},
            direction: 'column',
            justify: 'flex-end',
            align: 'center',
            p: remCalc(24),
            gap: remCalc(8),
            color: 'text.inverse',
            fontWeight: 700,
            textStyle: 'body-medium',
            position: 'relative',
        },
        title: {
            fontWeight: 700,
            textStyle: 'body-medium',
            whiteSpace: 'wrap',
        },
        button: {
            whiteSpace: 'wrap',
        },
    },
}
